import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './article.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Article } from "model/dealer/article.model";

export interface ArticleDetailsProps extends DetailsStateAndDispatchProps<Article,'articleStatus'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const ArticleDetails: FC<ArticleDetailsProps> = (props) => {
  return (
    <DetailsPage<Article,'articleStatus'>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Article>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ article }: RootState) => ({
  entity: article.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ArticleDetails);
